(function () {
  'use strict';

  var STONE_ROOT_SELECTOR = '[data-aner-card-stones]';
  var METAL_ROOT_SELECTOR = '[data-aner-card-metals]';
  var STONE_ITEM_SELECTOR = '[data-aner-card-stone]';
  var METAL_ITEM_SELECTOR = '[data-aner-card-metal]';
  var STONE_INITIALIZED = 'anerCollectionStonesInitialized';
  var METAL_INITIALIZED = 'anerCollectionMetalsInitialized';
  var STONE_VISIBLE_COUNT = 5;
  var METAL_VISIBLE_COUNT = 3;

  function shuffle(items) {
    for (var index = items.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var item = items[index];
      items[index] = items[randomIndex];
      items[randomIndex] = item;
    }
  }

  function applyRandomCount(items, visibleCount, more, noun) {
    if (items.length > visibleCount) {
      shuffle(items);
      items.forEach(function (item, index) {
        item.hidden = index >= visibleCount;
      });
    }

    if (!more) return;
    var hiddenCount = Math.max(0, items.length - visibleCount);
    more.hidden = hiddenCount === 0;
    if (hiddenCount > 0) {
      more.textContent = '+' + hiddenCount;
      more.setAttribute('aria-label', 'View ' + hiddenCount + ' more ' + noun);
    }
  }

  function initStoneRoot(root) {
    if (!root || root.dataset[STONE_INITIALIZED] === 'true') return;
    var stones = Array.prototype.slice.call(root.querySelectorAll(STONE_ITEM_SELECTOR));
    if (!stones.length) return;
    applyRandomCount(stones, STONE_VISIBLE_COUNT, root.querySelector('[data-aner-card-stones-more]'), 'main stones');
    root.dataset[STONE_INITIALIZED] = 'true';
  }

  function initMetalRoot(root) {
    if (!root || root.dataset[METAL_INITIALIZED] === 'true') return;
    var metals = Array.prototype.slice.call(root.querySelectorAll(METAL_ITEM_SELECTOR));
    if (!metals.length) return;
    applyRandomCount(metals, METAL_VISIBLE_COUNT, root.querySelector('[data-aner-card-metals-more]'), 'metal colours');
    root.dataset[METAL_INITIALIZED] = 'true';
  }

  function setMetalSwatchStyle() {
    document.documentElement.setAttribute('data-aner-metal-style', 'blocks');
  }

  function initAll(root) {
    initStoneRoot(root);
    initMetalRoot(root);
  }

  function boot(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    if (parent.matches && (parent.matches(STONE_ROOT_SELECTOR) || parent.matches(METAL_ROOT_SELECTOR))) {
      initAll(parent);
    }
    parent.querySelectorAll(STONE_ROOT_SELECTOR + ',' + METAL_ROOT_SELECTOR).forEach(initAll);
  }

  function scheduleBoot(scope) {
    window.requestAnimationFrame(function () {
      boot(scope);
    });
  }

  setMetalSwatchStyle();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        scheduleBoot(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (event) { scheduleBoot(event.target); });
})();